import { Capacitor, registerPlugin } from '@capacitor/core';

const isAndroidNative =
  Capacitor.isNativePlatform() &&
  Capacitor.getPlatform() === 'android';

const AudioRouter = isAndroidNative
  ? registerPlugin('AudioRouter')
  : null;

async function callPlugin(method, args) {
  if (!AudioRouter) return;
  try {
    await AudioRouter[method](args);
  } catch (err) {
    console.warn(`[AudioRouter] ${method} failed`, err);
  }
}

export async function setSpeakerRoute(enabled) {
  if (!isAndroidNative) return;
  await callPlugin('setRoute', { speakerOn: !!enabled });
}

export async function setAudioRoute(route) {
  if (!isAndroidNative) return { routed: false };
  try {
    const result = await AudioRouter.setRoute({ route });
    return result || { routed: true };
  } catch (err) {
    console.warn('[AudioRouter] setRoute failed', err);
    return { routed: false };
  }
}

export async function getBluetoothAvailable() {
  if (!isAndroidNative) return false;
  try {
    const result = await AudioRouter.getBluetoothAvailable();
    return result?.available === true;
  } catch (err) {
    console.warn('[AudioRouter] getBluetoothAvailable failed', err);
    return false;
  }
}

export async function resetSpeakerRoute() {
  if (!isAndroidNative) return;
  await callPlugin('reset');
}
